/**
 * @file: The grid options that change on a narrow screen.
 *
 * A week on a phone has columns of about 45px. A bar there has no space for
 * its text, and the default day header overlaps the next header. A narrow
 * screen therefore starts in the day view. The week view stays one press
 * away, and its day header becomes short.
 *
 * The breakpoint is in the LESS of the page. A media query there sets
 * --schedule-narrow, and this file reads that property. Thus the script and
 * the layout use one breakpoint. The script reads it one time, when the grid
 * starts. After that the operator picks the view.
 */

/** The custom property that the LESS of the page sets on a narrow screen. */
const NARROW_PROPERTY = '--schedule-narrow'

/** The first letter of the weekday and the day of the month, for example "M 7". */
const NARROW_DAY_HEADER = Object.freeze({ weekday: 'narrow', day: 'numeric' })

/**
 * Whether the page has the narrow layout.
 *
 * @param {HTMLElement} element - An element inside the page
 * @returns {boolean}
 */
export function isNarrowScreen (element) {
  return window.getComputedStyle(element).getPropertyValue(NARROW_PROPERTY).trim() === '1'
}

/**
 * The view that the grid starts in.
 *
 * @param {boolean} narrow
 * @returns {string} A view type of FullCalendar
 */
export function initialViewFor (narrow) {
  return narrow ? 'timeGridDay' : 'timeGridWeek'
}

/**
 * The options of the week view. A wide screen keeps the default of
 * FullCalendar, "Mon 07/09".
 *
 * @param {boolean} narrow
 * @returns {Object}
 */
export function weekViewOptionsFor (narrow) {
  return narrow ? { dayHeaderFormat: NARROW_DAY_HEADER } : {}
}
